/**
 * 회사(기공소·병원) 주소 조립 — 표시 전용 단일 헬퍼.
 *
 * 주소 4필드는 행정 층위다.
 *   addrOne   1급 — 시/도    · 省/自治区/直辖市
 *   addrTwo   2급 — 시/군/구  · 市
 *   addrThree 3급 — 읍/면/동  · 区/县
 *   addrDetail 상세
 *
 * [함정] 이전 로직은 `addrOne && addrTwo && addrThree` 를 **전부 요구**했다. 중국 회사는
 * 3급이 비어 있어 이 조건이 거짓이 되고, 성·시·구가 통째로 빠진 채 번지(addrDetail)만
 * 출력됐다 — 인증서 작업지시서에 「秦皇岛路32号B栋」처럼 찍혀 나갔다.
 * 그래서 **있는 층위만 이어 붙인다.**
 *
 * 직할시(上海市 上海市 奉贤区)는 1·2급에 같은 값이 반복 저장되므로 표시할 때
 * 연속 중복을 접는다 → 「上海市 奉贤区」.
 */
export function formatCompanyAddress(item) {
  const src = item || {};
  if (src.bizAddr) {
    return [src.bizAddr, src.addrDetail].filter(Boolean).join(' ').trim();
  }

  const levels = [src.addrOne, src.addrTwo, src.addrThree]
    .map((v) => (typeof v === 'string' ? v.trim() : ''))
    .filter(Boolean)
    // 연속 중복만 접는다(직할시 반복). 떨어져 있는 동명 지명은 건드리지 않는다.
    .filter((v, i, arr) => i === 0 || v !== arr[i - 1]);

  return [...levels, src.addrDetail].filter(Boolean).join(' ').trim();
}

export default formatCompanyAddress;
